export function isValidCVR(input: string, allowEmpty: boolean = true): boolean {
	if (!allowEmpty && !input)
		return false;
	const cvrnr: string = input.replace(/\D/g, '');
	if (!cvrnr) {
		return allowEmpty;
	}
	if (!/^\d{8}$/.test(cvrnr)) {
		return false;
	}

	let total: number = 0;
	[2, 7, 6, 5, 4, 3, 2, 1].forEach((elm, index) => {
		total += parseInt(cvrnr[index], 10) * elm;
	});

	return total % 11 === 0;
}

export function isNumber(input: string): boolean {
	return /^[0-9]+$/.test(input);
}

export function isValidQuantity(input: string, min: number, max: number): boolean {
	return isNumber(input) && Number(input) >= min && Number(input) <= max;
}

export function isValidEmail(input: string): boolean {
	const emailRegex = /^[a-zA-Z0-9.!#$%&amp;' * +/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/;
	return emailRegex.test(input);
}
